class JfseUtils {
    static jfseBirthDate2Moment(date: string) {
        const year = parseInt(date.substring(0, 4), 10);
        const month = parseInt(date.substring(4, 6), 10);
        const day = parseInt(date.substring(6, 8), 10);
        return Date.UTC(year, month - 1, day);
    }
}
export default JfseUtils;
